"use strict";
import Blocker from "./blocker";
export default React.createClass({
  getDefaultProps: function() {
    return {
      children: /* @__PURE__ */ React.createElement("div", null)
    };
  },
  render: function() {
    var child = React.Children.only(this.props.children);
    return /* @__PURE__ */ React.createElement(
      Blocker,
      {
        modalView: this.props.when ? this.spinner() : void 0,
        children: this.props.children
      }
    );
  },
  spinner: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "cg-busy-default-sign" }, /* @__PURE__ */ React.createElement("div", { className: "cg-busy-default-spinner" }, _.map(_.range(12), this.spinnerBar)), /* @__PURE__ */ React.createElement("div", { className: "cg-busy-default-text" }, "Please Wait..."));
  },
  spinnerBar: function(index) {
    return React.createElement("div", { className: "bar" + (index + 1), key: index });
  }
});
